<div class="pomodoroo">
<!--  <div class="not_connected" ngOffline>نت قطعه ...</div>-->
<!--  <div class="connected" ngOnline>ت وصله</div>-->
  <div
      [ngClass]="{'dark': pomodoroRepository.darkMode, 'ltr': pomodoroRepository.ltrDirection, 'arabic': pomodoroRepository.arabicMode,
    'german': pomodoroRepository.germanMode, 'spRuMode': pomodoroRepository.spRuMode, 'startTour': pomodoroRepository.startTour,
    'ctlOne': pomodoroRepository.ctlOne, 'ctlTwo': pomodoroRepository.ctlTwo, 'ctlThree': pomodoroRepository.ctlThree,
    'ctlFour': pomodoroRepository.ctlFour,'ctlFive': pomodoroRepository.ctlFive, 'ctlSix': pomodoroRepository.ctlSix,
    'ctlSeven': pomodoroRepository.ctlSeven, 'ctlEight': pomodoroRepository.ctlEight, 'ctlNine': pomodoroRepository.ctlNine,
    'ctlTen': pomodoroRepository.ctlTen, 'menu-condition': pomodoroRepository.isMenuOpen}">
    <div id="header" class="container-fluid" [ngClass]="{'toggle': pomodoroRepository.clickToggle}">
      <div class="container">
        <div class="logo" routerLink="/">{{ 'MyPomodoro' | translate}}</div>
        <div class="menu_mobile_button" (click)="openMenu()">{{ 'menu' | translate}}</div>
        <div class="menu_mobile_frame" [ngClass]="{'d-block': pomodoroRepository.showMobile, 'd-none': !pomodoroRepository.showMobile }">
          <div class="close_menu_mobile_frame" (click)="closeMenu()">×</div>
          <div class="select_language_mobile">
            <div class="current_language" (click)="pomodoroRepository.openMenu()">
              <div class="current_language_flag">
                <img src="{{pomodoroRepository.defaultFlag}}" alt="Persian">
              </div>
              <div class="current_language_name">{{pomodoroRepository.defaultFlagName}}</div>
              <div class="clearfix"></div>
            </div><!-- .current_language -->
            <div class="other_language_mobile">
              <ul>
                <li (click)="pomodoroRepository.farsiLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/persian.png" alt="Persian">
                  </div>
                  <div class="current_language_name">فارسی</div>
                  <div class="clearfix"></div>
                </li>
                <li (click)="pomodoroRepository.englishLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/english.png" alt="English">
                  </div>
                  <div class="current_language_name">English</div>
                  <div class="clearfix"></div>
                </li>
                <li (click)="pomodoroRepository.arabianLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/arabic.png" alt="العربیه">
                  </div>
                  <div class="current_language_name">العربیة</div>
                  <div class="clearfix"></div>
                </li>
                <li (click)="pomodoroRepository.spanishLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/spanish.png" alt="Español">
                  </div>
                  <div class="current_language_name">Español</div>
                  <div class="clearfix"></div>
                </li>
                <li (click)="pomodoroRepository.deutschLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/german.png" alt="Deutsch">
                  </div>
                  <div class="current_language_name">Deutsch</div>
                  <div class="clearfix"></div>
                </li>
                <li (click)="pomodoroRepository.russianLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/russian.png" alt="Русский">
                  </div>
                  <div class="current_language_name">Русский</div>
                  <div class="clearfix"></div>
                </li>
                <li (click)="pomodoroRepository.hindiLang()">
                  <div class="current_language_flag">
                    <img src="assets/image/indian.png" alt="हिन्दी">
                  </div>
                  <div class="current_language_name">हिन्दी</div>
                  <div class="clearfix"></div>
                </li>
              </ul>
            </div><!-- .other_language -->
          </div><!-- .select_language -->
          <div class="header_mobile">
            <ng-container *ngIf="pomodoroRepository.userIsLoggedIn">
              <div class="sign_out"><a (click)="logOut()">{{ 'LogOut' | translate}}</a></div>
              <div class="sign_in" (click)="pomodoroRepository.navigateToProfile()"><a>{{ 'Profile' | translate}}</a></div>
            </ng-container>
            <ng-container *ngIf="!pomodoroRepository.userIsLoggedIn">
              <div class="sign_in" (click)="pomodoroRepository.navigateToLogin()"><a>{{ 'LogIn' | translate}}</a></div>
            </ng-container>
          </div>
          <div class="main_menu_mobile">
            <ul>
              <li><a (click)="pomodoroRepository.navigateToPomodoroTimer()">{{ 'pomodoroTimer' | translate }}</a></li>
              <li><a href="https://mypomodoro.ir/blog/" target="_blank">{{ 'Blog' | translate }}</a></li>
              <li><a (click)="pomodoroRepository.navigateToStatistics()">{{ 'Ranking' | translate }}</a></li>
              <li><a (click)="pomodoroRepository.navigateToSetting()">{{ 'Setting' | translate }}</a></li>
            </ul>
            <router-outlet></router-outlet>
          </div>
        </div>
        <div class="select_language">
          <!--        <div class="current_language" (click)="pomodoroRepository.openMenu()">-->
          <div class="current_language" #toggleMom (click)="toggleMenu()">
            <div class="current_language_flag">
              <img class="current_language_flag" src="{{pomodoroRepository.defaultFlag}}" alt="Persian" #toggleButton>
            </div>
            <div class="current_language_name" #toggleText>{{pomodoroRepository.defaultFlagName}}</div>
            <div class="clearfix"></div>
            <!--          {{pomodoroRepository.defaultFlagName}}-->
          </div><!-- .current_language -->
          <div class="other_language" #menu>
            <ul>
              <li (click)="pomodoroRepository.farsiLang()">
                <div class="current_language_flag">
                  <img src="assets/image/persian.png" alt="Persian">
                </div>
                <div class="current_language_name">فارسی</div>
                <div class="clearfix"></div>
              </li>
              <li (click)="pomodoroRepository.englishLang()">
                <div class="current_language_flag">
                  <img src="assets/image/english.png" alt="English">
                </div>
                <div class="current_language_name">English</div>
                <div class="clearfix"></div>
              </li>
              <li (click)="pomodoroRepository.arabianLang()">
                <div class="current_language_flag">
                  <img src="assets/image/arabic.png" alt="العربیه">
                </div>
                <div class="current_language_name">العربیة</div>
                <div class="clearfix"></div>
              </li>
              <li (click)="pomodoroRepository.spanishLang()">
                <div class="current_language_flag">
                  <img src="assets/image/spanish.png" alt="Español">
                </div>
                <div class="current_language_name">Español</div>
                <div class="clearfix"></div>
              </li>
              <li (click)="pomodoroRepository.deutschLang()">
                <div class="current_language_flag">
                  <img src="assets/image/german.png" alt="Deutsch">
                </div>
                <div class="current_language_name">Deutsch</div>
                <div class="clearfix"></div>
              </li>
              <li (click)="pomodoroRepository.russianLang()">
                <div class="current_language_flag">
                  <img src="assets/image/russian.png" alt="Русский">
                </div>
                <div class="current_language_name">Русский</div>
                <div class="clearfix"></div>
              </li>
              <li (click)="pomodoroRepository.hindiLang()">
                <div class="current_language_flag">
                  <img src="assets/image/indian.png" alt="हिन्दी">
                </div>
                <div class="current_language_name">हिन्दी</div>
                <div class="clearfix"></div>
              </li>
            </ul>
          </div><!-- .other_language -->
        </div><!-- .select_language -->
        <div class="header_desctop">
<!--          <ng-container *ngIf="pomodoroRepository.userIsLoggedIn">-->
          <ng-container *ngIf="pomodoroRepository.userIsLoggedIn">
            <div class="sign_out"><a (click)="logOut()">{{ 'LogOut' | translate}}</a></div>
            <div class="sign_in" [routerLink]="['/profile']"><a>{{ 'Profile' | translate}}</a></div>
          </ng-container>
          <ng-container *ngIf="!pomodoroRepository.userIsLoggedIn">
            <div class="sign_in" [routerLink]="['/login']"><a>{{ 'LogIn' | translate}}</a></div>
          </ng-container>
        </div>
        <div class="main_menu">
          <ul>
            <li><a [routerLink]="['/']">{{ 'pomodoroTimer' | translate }}</a></li>
            <li><a href="https://mypomodoro.ir/blog/" target="_blank">{{ 'Blog' | translate }}</a></li>
            <li><a [routerLink]="['/Statistics']">{{ 'Ranking' | translate }}</a></li>
            <li><a [routerLink]="['/setting']">{{ 'Setting' | translate }}</a></li>
          </ul>
          <router-outlet></router-outlet>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
<!--    <div class="connection_alarm" *ngIf="appIsConnected == 'notConnected'">-->
        <div ngOffline>
          <div class="connection_alarm">
            <div class="connection_label"></div>
            <div class="connection_icon">
              <img src="assets/icons/connection.svg" alt="">
            </div>
            <div class="connection_text">
              <div class="connection_title">
                اینترنت خود را بررسی کنید.
              </div>
              <div class="connection_description">
                ممکن است در ارسال اطلاعات با مشکل مواجه شوید.
              </div>
            </div>
          </div>
        </div>
    <div class="notification_request_alarm" [@animation]="stateName" *ngIf="showNotificationAlert">
      <div class="notification_request_right">
        <div class="notification_request_icon">
          <img src="assets/icons/Hourglass.svg" alt="">
        </div>
      </div>
      <div class="notification_request_left">
        <div class="notification_request_text">
          <div class="notification_request_title">
            نوتیفیکیشن پومودورو را فعال کنید.
          </div>
          <div class="notification_request_description">
            با فعال کردن این قابلیت زمان های شروع پومودورو و استراحت به شما اطلاع رسانی خواهد شد.
          </div>
        </div>
        <div class="notification_request_dismiss" (click)="dismissRequestPermission()">
          &times;
        </div>
        <button class="notification_request_button" (click)="sendRequestPermission()">اعمال</button>
        <div class="notification_request_hint">
          در مرحله بعد روی دکمه Allow کلیک کنید.
        </div>
      </div>
    </div>
    <div class="notification_request_alarm" style="height: 60px" [@animation]="stateName" *ngIf="pomodoroRepository.allTasksAreCompleted">
      <div class="notification_request_right">
        <div class="completed_task_icon">
          <img src="assets/image/logo.svg" alt="">
        </div>
      </div>
      <div class="notification_request_left">
        <div class="notification_request_text">
          <div class="completed_task_description">
            تبریک! شما همه‌ی کارهاتون رو انجام دادید! :)
          </div>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
